import { Table } from "react-bootstrap";

export const INITIAL_KIV_MODAL_INFO = {
    size: "sm",
    notifMsg: "",
    open: false,
    severity: "danger",
    static: false,
};

export const StatusSummaryTable = ({ rows, preview = false }) => {
    const items = Object.values(rows ?? {});
    if (items.length === 0) return null;

    const stickyHeaderStyle = {
        backgroundColor: "#f2f2f2",
        position: "sticky",
        top: 0,
        zIndex: 1,
    };

   console.log(items);

    return (
        <div className="row table-responsive" style={{ maxHeight: "470px" }}>
            <h3>Summary of Status Changes</h3>
            <h5 className="text-start">{`Total Count of Selected: ${items.length}`}</h5>
            <Table className="table">
                <thead>
                    <tr>
                        <th style={stickyHeaderStyle}>Student Name</th>
                        <th style={stickyHeaderStyle}>Fin</th>
                        <th style={stickyHeaderStyle}>
                            {preview ? "Current Status" : "Old Status"}
                        </th>
                        {!preview && (
                            <th style={stickyHeaderStyle}>New Status</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={item?.id ?? index}>
                            <td>{item?.name ?? ""}</td>
                            <td>{item?.fin ?? ""}</td>
                            <td>
                                {(preview ? item?.status : item?.old_status) ??
                                    ""}
                            </td>
                            {!preview && <td>{item?.new_status ?? ""}</td>}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};
